import { Component, OnInit } from '@angular/core';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { QFilterModel } from '../../../../models/qfilter.model';
import { IndicatorBoxModel } from '../../../../models/indicator-box.model';
import { IndicatorsService } from '../../../../services/indicators/indicators.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';
import { NumberKMPipe } from '../../../../pipes/numberKMPipe';

// Pagina 33
@Component({
  selector: 'app-analysis-promo',
  templateUrl: './analysis-promo.component.html',
  styleUrls: ['./analysis-promo.component.css']
})
export class AnalysisPromoComponent implements OnInit {
  public translations: any;
  public datatable: Array<any>;

  public data: QFilterModel;

  public indicators: IndicatorBoxModel[] = [];
  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public ripartionPromoChart: LoyaltyChart;

  public ripartionPromo: string;

  public storeError = false;
  public selectOneError: string;

  constructor(
    private translate: TranslateService,
    private indicatorService: IndicatorsService,
  ) { }

  ngOnInit() {

    this.translations = {};

    this.translate.get([
      'store.ripartionPromo',
      'store.nomePromo',
      'store.typePromo',
      'store.startPromo',
      'store.endPromo',
      'store.investmentPromo',
      'store.invoicePromo',
      'store.expensePromo',
      'store.discountPromo',
      'store.quantityPromo',
      'store.adhesionPromo'
    ]).subscribe(t => {
      this.translations = {
        ripartionPromo: t['store.ripartionPromo'],
        nomePromo: t['store.nomePromo'],
        typePromo: t['store.typePromo'],
        startPromo: t['store.startPromo'],
        endPromo: t['store.endPromo'],
        investmentPromo: t['store.investmentPromo'],
        invoicePromo: t['store.invoicePromo'],
        expensePromo: t['store.expensePromo'],
        discountPromo: t['store.discountPromo'],
        quantityPromo: t['store.quantityPromo'],
        adhesionPromo: t['store.adhesionPromo']
      };

      this.ripartionPromo = t['store.ripartionPromo'];
    });

    this.translate.get('store.selectOneErrorMsg').subscribe(msg => { this.selectOneError = msg; });
    this.initChart();
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  initChart() {
    this.ripartionPromoChart = (new LoyaltyChart('bar', '%'));
    this.ripartionPromoChart.options.plotOptions = {series: {stacking: 'percent'}};
    this.ripartionPromoChart.options.legend = {layout: 'vertical', align: 'right', verticalAlign: 'top'};

    this.ripartionPromoChart.options.tooltip = {
      formatter: function () {
        return this.points.reduce (
          function (s, point) {
            return s + '<br/>' + point.series.name + ': ' +
              NumberKMPipe.formatDynamic(point.y, '€');
          }, '<b>' + this.x + '</b>'
        );
      },
      shared: true
    };
  }

  searchValueTrend(data: QFilterModel) {
    this.data = data;
    if (data['stores'] != null) {

      this.indicators = [];

      Observable.zip(
        this.indicatorService.indicatorCalculation('stores.Q147', this.data),
        this.indicatorService.indicatorCalculation('stores.Q149', this.data)
      ).subscribe(
        ([a, b]) => {

          /*147*/
          this.indicators.push(new IndicatorBoxModel([a.find(r => r.name === 'investimento')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}, null));
          /*148*/
          this.indicators.push(new IndicatorBoxModel([a.find(r => r.name === 'sconto_medio')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}, null));
          /*149*/
          this.indicators.push(new IndicatorBoxModel([b.find(r => r.name === 'sconto_medio_volantino')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}, null));
          /*150*/
          this.indicators.push(new IndicatorBoxModel([a.find(r => r.name === 'sconto_medio_loyalty')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}, null));
        });

      this.ripartionPromoInit (data);
      this.tableInit (data);


    } else {
      this.data = null;
      this.storeError = true;
    }
  }

  ripartionPromoInit (data: QFilterModel) {


    Observable.zip (
      this.indicatorService.getChart('stores.Q151', data, false)
    ).subscribe( ([res]) => {

      let serie0 = res.series[0].serie;
      let serie1 = res.series[1].serie;
      let serie2 = res.series[2].serie;
      const xAxis = {
        serie: serie0.filter(function (value, index, self) {
          return self.indexOf(value) === index;
        })
      };

      let series: Array<any> = [];
      for (let i = 0; i < serie0.length; i++) {
        let elem = series.find(function (el) {
          return el.name === serie1[i];
        });
        if (typeof elem === 'undefined') {
          series.push({name: serie1[i], data: [serie2[i]]});
        } else {
          elem.data.push(serie2[i]);
        }
      }

      if (this.ripartionPromoChart.instance) {
        while (this.ripartionPromoChart.instance.series.length > 0) {
          this.ripartionPromoChart.instance.series[0].remove(true);
        }
      }

      this.ripartionPromoChart.options.xAxis.categories = xAxis.serie;

      for (let i = 0; i < series.length; i++) {

        this.ripartionPromoChart.instance.addSeries(series[i]);
      }

      this.ripartionPromoChart.instance.update(this.ripartionPromoChart.options);
      this.ripartionPromoChart.instance.redraw();
    });

  }

  public tableInit (data: QFilterModel) {
    this.indicatorService.getChart('stores.Q152', data).subscribe((resp) => {

      this.datatable = [];
      if (resp.series.length > 0) {
        let serie0  = resp.series[0].serie;
        let serie1  = resp.series[1].serie;
        let serie2  = resp.series[2].serie;
        let serie3  = resp.series[3].serie;
        let serie4  = resp.series[4].serie;
        let serie6  = resp.series[6].serie;
        let serie8  = resp.series[8].serie;
        let serie10 = resp.series[10].serie;
        let serie12 = resp.series[12].serie;
        let serie13 = resp.series[13].serie;
        for (let i = 0; i < serie0.length; i++) {

          this.datatable.push({
            nomePromo:          serie1[i],
            typePromo:          serie0[i],
            startPromo:         this.formatDate (serie2[i]),
            endPromo:           this.formatDate (serie3[i]),
            investmentPromo:    NumberKMPipe.formatDynamic(+serie4[i], '€'),
            invoicePromo:       NumberKMPipe.formatDynamic(+serie6[i], '€'),
            expensePromo:       NumberKMPipe.formatDynamic(+serie8[i], '€'),
            discountPromo:      serie10[i] + '%',
            quantityPromo:      NumberKMPipe.formatDynamic(+serie12[i]),
            adhesionPromo:      serie13[i] + '%',
          });
        }
      }

    });
  }

  public toogleErrorStoreDialog() {
    this.storeError = !this.storeError;
  }

  public resetData() {
    this.data = null;
    this.indicators = [];
  }

  private formatDate (d) {
    let parts = d.split('-');
    return parts[2] + '/' + parts[1] + '/' + parts[0];
  }
}



// WEBPACK FOOTER //
// ./src/app/views/store/analysis/analysis-promo/analysis-promo.component.ts